/* @ngInject */
const confirmation = (valueHandler) => {
  return {
    require: 'ngModel',
    link: (scope, elm, attrs, ctrl) => {
      ctrl.$validators.confirmation = (modelValue, viewValue) => {
        if (valueHandler.isEmpty(attrs.confirmation)) {
          return true
        }
        if (attrs.confirmation === modelValue) {
          return true
        }
        return false
      }

      attrs.$observe('confirmation', (val) => {
        ctrl.$validate()
      })
    },
  }
}

export default confirmation



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/confirmation.js